<template>
  <div>
    <navbar back fixed bg>
      <span slot="title">{{itemList[0].title}}</span>
    </navbar>
    <div class="page-content">
      <scroller ref="scroller">
        <div class="about">
          <div class="wrap-about indent" v-html="itemList[0].content">
          </div>
          <div class="wrap-about"  v-for="(item,index) in itemList" v-if="index > 0">
            <h3 class="title">{{itemList[index].title}}</h3>
            <div v-html="itemList[index].content"></div>
          </div>
        </div>
        <!-- <div class="tel">
          <span class="iconfont">&#xe602;</span>
          	贷款金融热线：400-770-5127
        </div> -->
      </scroller>
    </div>
  </div>
</template>

<script>
  import Navbar from 'components/navbar/navbar'
  import Scroller from 'components/scroller/scroller'

  export default {
    data () {
      return {
        itemList: {}
      }
    },
    created () {
      this.getItemList()
    },
    components: {Navbar, Scroller},
    mounted () {
      this.getItemList()
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.scroller.resize()
        }, 500)
      })
    },
    methods: {
      getItemList () {
        let vm = this
        this.$ajax({
          url: '/getAboutUsArticleInfo.jhtml',
          params: {
            type: 5
          },
          done (result) {
            vm.itemList = [].concat(result)
          }
        })
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '../../common/css/mixmin'

  .about
    margin px2rem(20) 1em px2rem(40)
    .wrap-about
      margin-bottom px2rem(20)
      padding px2rem(20) 1em
      border-radius px2rem(5)
      background-color #fff
      box-shadow 0 px2rem(10) px2rem(15) rgba(171,185,197, 1)
      p
        margin 0
        font-size px2rem(24)
        color #4e465a
        line-height 1.5
      .title
        margin 0 0 px2rem(10)
        font-size px2rem(28)
        color #275482
      p.indent
        text-indent 2em
      .list-bank
        margin 0
        padding 0
        overflow hidden
        font-size px2rem(24)
        color #4e465a
        .bank
          float left
          margin px2rem(5) px2rem(10) px2rem(5) 0
          list-style-type none

  .tel
    margin-bottom px2rem(40)
    font-size px2rem(28)
    color #275482
    font-weight 600
    text-align center
    .iconfont
      font-weight 600
</style>



// WEBPACK FOOTER //
// about.vue?db937c58